export default __webpack_public_path__ + "img/15.14342a90.jpg";